import type { SxProps } from "@mui/material";
import { Box } from "@mui/material";
import type { FC, ReactNode } from "react";
import { FOOTER_HEIGHT } from "./fixed-footer";

export const PageWithFooterWrapper: FC<{ children: ReactNode; sx?: SxProps }> = ({
  children,
  sx = [],
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        height: `calc(100% - ${FOOTER_HEIGHT})`,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
